<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="项目方资金余额" name="balanceCollect">
      <div>
        <el-card>
          <div class="block">
            <el-form :inline="true">
              <el-form-item label="币种名称：">
                <el-input v-model="coinName" placeholder="请输入币种名称" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryPartnerBalanceCollect">搜索</el-button>
              </el-form-item>
            </el-form>
            <div v-if="isShow">
              <div style="text-align:right">
                <el-button size="small" type="danger" icon="el-icon-s-unfold" :plain="true" @click="showOriginData" style="text-align: right">原始数据</el-button>
                <el-button size="small" type="danger" icon="el-icon-s-unfold" :plain="true" @click="showMergeData" style="text-align: right">合成数据</el-button>
              </div>
              <el-table :data="tableData" border>
                <el-table-column prop="userId" label="用户ID" sortable></el-table-column>
                <el-table-column prop="coin" label="币种" sortable></el-table-column>
                <el-table-column prop="coinArea" label="计价币" sortable></el-table-column>
                <el-table-column prop="coinDeposit" label="充值代币量(币)" sortable></el-table-column>
                <el-table-column prop="coinWithdrawal" label="提现代币" sortable></el-table-column>
                <el-table-column prop="USDTDeposit" label="充值资金量U" sortable></el-table-column>
                <el-table-column prop="USDTWithdrawal" label="提现资金" sortable></el-table-column>
                <el-table-column prop="yesterdayCoin" label="昨日市值代币" sortable></el-table-column>
                <el-table-column prop="coinTotalAmount" label="市值代币余额" sortable></el-table-column>
                <el-table-column prop="yesterdayMarket" label="昨日市值资金" sortable></el-table-column>
                <el-table-column prop="USDTMarketFund" label="市值资金余额" sortable></el-table-column>
                <el-table-column prop="coinBenefit" label="代币增减(盈亏)" sortable></el-table-column>
                <el-table-column prop="USDTBenefit" label="资金增减(盈亏)" sortable></el-table-column>
                <el-table-column prop="yesterdayUSDTChange" label="昨日资金变化" sortable></el-table-column>
                <el-table-column prop="yesterdayCoinChange" label="昨日变化代币" sortable></el-table-column>
                <el-table-column prop="avgPrice" label="均价" sortable></el-table-column>
                <el-table-column prop="platformTotalAmt" label="平台代币总量" sortable></el-table-column>
                <el-table-column prop="coinFlowAmt" label="流通数量" sortable></el-table-column>
                <el-table-column prop="currentCoinPrice" label="现价" sortable></el-table-column>
                <el-table-column prop="coinFlowMarket" label="流通代币市值U" sortable></el-table-column>
                <el-table-column prop="marketBalanceStd" label="市值资金标准" sortable></el-table-column>
              </el-table>
              <el-pagination background
                             layout="total, sizes, prev, pager, next, jumper"
                             :page-size="pageSize"
                             :page-sizes="[5, 10, 20]"
                             :total="total"
                             :current-page="currentPageNum"
                             @size-change="handleSizeChange"
                             @current-change="handleCurrentChange">
              </el-pagination>
              <div style="text-align: right">
                <el-button  size="small" type="primary" icon="el-icon-refresh" :plain="true" @click="exportExcel">导出excel</el-button>
              </div>
            </div>
          </div>
        </el-card>

      </div>
    </el-tab-pane>
    <el-tab-pane label="项目方" name="srcRecords">
      <partner-info></partner-info>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import utils from './utils'
import PartnerInfo from "./PartnerInfo";

const columns=[
  {title:'用户ID',key:'userId'},
  {title:'币种',key:'coin'},
  {title:'计价币',key:'coinArea'},
  {title:'充值代币量(币)',key:'coinDeposit'},
  {title:'提现代币',key:'coinWithdrawal'},
  {title:'充值资金量U',key:'USDTDeposit'},
  {title:'提现资金',key:'USDTWithdrawal'},
  {title:'昨日市值代币',key:'yesterdayCoin'},
  {title:'市值代币余额',key:'coinTotalAmount'},
  {title:'昨日市值资金',key:'yesterdayMarket'},
  {title:'市值资金余额',key:'USDTMarketFund'},
  {title:'代币增减(盈亏)',key:'coinBenefit'},
  {title:'资金增减(盈亏)',key:'USDTBenefit'},
  {title:'昨日资金变化',key:'yesterdayUSDTChange'},
  {title:'昨日变化代币',key:'yesterdayCoinChange'},
  {title:'均价',key:'avgPrice'},
  {title:'平台代币总量',key:'platformTotalAmt'},
  {title:'流通数量',key:'coinFlowAmt'},
  {title:'现价',key:'currentCoinPrice'},
  {title:'流通代币市值U',key:'coinFlowMarket'},
  {title:'市值资金标准',key:'marketBalanceStd'},
]

export default {
  name: "index",
  components: {PartnerInfo},
  comments:{'PartnerInfo':PartnerInfo},
  data(){
    return{
      buffer:[],
      isShow:false,
      cache:'',
      coinName:'',
      tableData:[],
      mergeData:[],
      originData:[],
      total:0,
      pages: '',
      currentPageNum:1,
      pageSize: 10,
      activeName:'balanceCollect',
    }
  },
  methods:{

    handleSizeChange(val){
      this.params.pageSize = val
      this.queryPartnerBalanceCollect()
    },
    handleCurrentChange(val) {
      this.params.pageNum = val
      this.queryPartnerBalanceCollect()
    },

    deepCopy(source) {
      let sourceCopy = source instanceof Array ? [] : {};
      for (let item in source) {
        sourceCopy[item] = typeof source[item] === 'object' ? this.deepCopy(source[item]) : source[item];
      }
      return sourceCopy;
    },

    queryPartnerBalanceCollect(){
      if (this.cache === ''){
        this.cache = this.deepCopy(this.params.coinName)
      } else {
        if (this.cache !== this.params.coinName && this.params.coinName !== ''){
          this.params.pageNum = 1
        }
      }
      utils.queryPartnerBalanceCollect(this.params).then((response)=>{
        this.isShow = true
        this.total = response.data.total
        this.pages = response.data.pages
        this.pageSize = response.data.size
        this.currentPageNum = response.data.current
        this.buffer = this.deepCopy(response.data.records)
        this.originData = this.deepCopy(response.data.records)
        this.tableData = this.originData
        let dataDict = {}
        for(let i in this.buffer){
          let coin = this.buffer[i].coin
          if (Object.keys(dataDict).indexOf(coin) === -1){
            dataDict[coin] =  this.buffer[i]
          }else{
            dataDict[coin].userId = "******"
            // 充值代币
            dataDict[coin].coinDeposit = dataDict[coin].coinDeposit + this.buffer[i].coinDeposit
            // 提现代币
            dataDict[coin].coinWithdrawal = dataDict[coin].coinWithdrawal + this.buffer[i].coinWithdrawal
            // 充值资金量U
            dataDict[coin].USDTDeposit = dataDict[coin].USDTDeposit +this.buffer[i].USDTDeposit
            // 提现资金
            dataDict[coin].USDTWithdrawal = dataDict[coin].USDTWithdrawal + this.buffer[i].USDTWithdrawal
            // 昨日市值代币
            dataDict[coin].yesterdayCoin = dataDict[coin].yesterdayCoin + this.buffer[i].yesterdayCoin
            // 市值代币余额
            dataDict[coin].coinTotalAmount = dataDict[coin].coinTotalAmount + this.buffer[i].coinTotalAmount
            // 昨日市值资金
            dataDict[coin].yesterdayMarket = dataDict[coin].yesterdayMarket + this.buffer[i].yesterdayMarket
            // 市值资金余额
            dataDict[coin].USDTMarketFund = dataDict[coin].USDTMarketFund + this.buffer[i].USDTMarketFund
            // 代币增减(盈亏)
            dataDict[coin].coinBenefit = dataDict[coin].coinBenefit + this.buffer[i].coinBenefit
            // 资金增减(盈亏)
            dataDict[coin].USDTBenefit = dataDict[coin].USDTBenefit + this.buffer[i].USDTBenefit
            // 昨日资金变化
            dataDict[coin].yesterdayUSDTChange = dataDict[coin].yesterdayUSDTChange + this.buffer[i].yesterdayUSDTChange
            // 昨日变化代币
            dataDict[coin].yesterdayCoinChange = dataDict[coin].yesterdayCoinChange + this.buffer[i].yesterdayCoinChange
            // 均价
            if (dataDict[coin].yesterdayCoinChange !== 0){
              dataDict[coin].avgPrice = dataDict[coin].yesterdayUSDTChange / dataDict[coin].yesterdayCoinChange
            }else {
              dataDict[coin].avgPrice = 0
            }
            // 流通数量
            if (dataDict[coin].platformTotalAmt){
              dataDict[coin].coinFlowAmt = dataDict[coin].platformTotalAmt - dataDict[coin].coinTotalAmount
            }
            // 流通代币市值U
            if (dataDict[coin].platformTotalAmt){
              dataDict[coin].coinFlowMarket = dataDict[coin].coinFlowAmt * dataDict[coin].currentCoinPrice
            }
            // 市值资金标准
            if (dataDict[coin].coinFlowMarket){
              dataDict[coin].marketBalanceStd = dataDict[coin].USDTMarketFund - dataDict[coin].coinFlowMarket * 0.7
            }
          }
        }
        this.mergeData = Object.values(dataDict)
      })
    },
    showMergeData(){
      this.tableData = this.mergeData
    },
    showOriginData(){
      this.tableData = this.originData
    },

    async exportExcel(){
      let mergeData = []
      let buffer = []
      let tmpData = []
      let dataDict = {}
      while (true){
        await utils.queryPartnerBalanceCollect(this.paramsBak).then((response)=>{
          tmpData = response.data.records
          buffer = buffer.concat(this.deepCopy(tmpData))
        })
        if (tmpData.length < 100){
          break
        }else{
          this.paramsBak.pageNum ++
        }
      }
      for(let i in buffer){
        let coin = buffer[i].coin
        if (Object.keys(dataDict).indexOf(coin) === -1){
          dataDict[coin] =  buffer[i]
        }else{
          dataDict[coin].userId = "******"
          // 充值代币
          dataDict[coin].coinDeposit = dataDict[coin].coinDeposit + buffer[i].coinDeposit
          // 提现代币
          dataDict[coin].coinWithdrawal = dataDict[coin].coinWithdrawal + buffer[i].coinWithdrawal
          // 充值资金量U
          dataDict[coin].USDTDeposit = dataDict[coin].USDTDeposit +buffer[i].USDTDeposit
          // 提现资金
          dataDict[coin].USDTWithdrawal = dataDict[coin].USDTWithdrawal + buffer[i].USDTWithdrawal
          // 昨日市值代币
          dataDict[coin].yesterdayCoin = dataDict[coin].yesterdayCoin + buffer[i].yesterdayCoin
          // 市值代币余额
          dataDict[coin].coinTotalAmount = dataDict[coin].coinTotalAmount + buffer[i].coinTotalAmount
          // 昨日市值资金
          dataDict[coin].yesterdayMarket = dataDict[coin].yesterdayMarket + buffer[i].yesterdayMarket
          // 市值资金余额
          dataDict[coin].USDTMarketFund = dataDict[coin].USDTMarketFund + buffer[i].USDTMarketFund
          // 代币增减(盈亏)
          dataDict[coin].coinBenefit = dataDict[coin].coinBenefit + buffer[i].coinBenefit
          // 资金增减(盈亏)
          dataDict[coin].USDTBenefit = dataDict[coin].USDTBenefit + buffer[i].USDTBenefit
          // 昨日资金变化
          dataDict[coin].yesterdayUSDTChange = dataDict[coin].yesterdayUSDTChange + buffer[i].yesterdayUSDTChange
          // 昨日变化代币
          dataDict[coin].yesterdayCoinChange = dataDict[coin].yesterdayCoinChange + buffer[i].yesterdayCoinChange
          // 均价
          if (dataDict[coin].yesterdayCoinChange !== 0){
            dataDict[coin].avgPrice = dataDict[coin].yesterdayUSDTChange / dataDict[coin].yesterdayCoinChange
          }else {
            dataDict[coin].avgPrice = 0
          }
          // 流通数量
          if (dataDict[coin].platformTotalAmt){
            dataDict[coin].coinFlowAmt = dataDict[coin].platformTotalAmt - dataDict[coin].coinTotalAmount
          }
          // 流通代币市值U
          if (dataDict[coin].platformTotalAmt){
            dataDict[coin].coinFlowMarket = dataDict[coin].coinFlowAmt * dataDict[coin].currentCoinPrice
          }
          // 市值资金标准
          if (dataDict[coin].coinFlowMarket){
            dataDict[coin].marketBalanceStd = dataDict[coin].USDTMarketFund - dataDict[coin].coinFlowMarket * 0.7
          }
        }
      }
      mergeData = Object.values(dataDict)
      let startTime = utils.getLocalTime(new Date())
      let title = '项目方资金汇总' + startTime
      utils.export2Excel(columns, mergeData, title)
    }
  },
  created() {
  },
  computed:{
    params() {
      return {
        coinName:this.coinName,
        pageSize:this.pageSize,
        pageNum:this.currentPageNum
      };
    },
    paramsBak() {
      return {
        coinName:'',
        pageSize:100,
        pageNum:1
      };
    }
  }
}
</script>
<style scoped>

</style>